import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Set Chart Aspect',
    description:
      'Binds an aspect of a chart to a new table column. Note that this can only be used for charts on a dashboard that are defined in a direct way in the template (and not e.g. via a gallery plot compound element)',
    properties: {
      type: { type: 'string', const: 'SetChartAspect' },
      chartId: {
        type: 'string',
        description: 'Identifier of the chart in the dashboad template for which an aspect should be modified.',
      },
      aspect: {
        type: 'string',
        description: 'Specifies what aspect of the chart should be modified.',
      },
      colId: {
        type: 'string',
        description: 'Specifies to what table column this aspect should be bound to.',
      },
    },
    required: ['type', 'chartId', 'aspect', 'colId'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  const chartTemplateId = step.chartId; // in the template action definition, the user enters the same chart id as for the definition of the chart in the template
  const chartIds = ctx.dashboardContext.getChartDefsFromTemplateId(chartTemplateId).map((chartDef) => chartDef.id);
  chartIds.forEach((chartId) => ctx.dashboardContext.updateChartAspectBinding(chartId, step.aspect, step.colId));
  onCompleted();
}

const dbActionStepSetChartAspect: TpDbActionStepTypeDefinition = {
  stepType: 'SetChartAspect',
  execute,
  getJsonSchema,
};

export default dbActionStepSetChartAspect;
